import { getCollectionOrderById } from "@/api/collectionOrder";
import { useState, useEffect } from "react";

const useCollectionById = (id: string) => {
  const [collections, setCollection] = useState<CollectionOrder | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCollection = async () => {
      try {
        const response = await getCollectionOrderById(id);
        console.log("Collection:", response);

        setCollection(response);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching Collection:", error);
        setLoading(false);
      }
    };

    fetchCollection();
  }, [id]);

  return { ...collections, loading };
};

export default useCollectionById;
